import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { Document } from 'src/app/models/document.model';
import { SignatureRequest } from 'src/app/models/signature-request.model';
import { ApiService } from 'src/app/services/api.service';
import { UtilsService } from 'src/app/services/utils.service';
import { INVALIDATED_LINK_MESSAGE } from 'src/app/constants/api-messages';

@Component({
  selector: 'app-popup-progress-signing',
  templateUrl: './popup-progress-signing.component.html',
  styleUrls: ['./popup-progress-signing.component.sass']
})
export class PopupProgressSigningComponent implements OnInit {

  private signature_request:SignatureRequest;
  private signature:Blob;
  private dni:string|null = null;
  public status:"signing"|"success"|"error"|"already_signed" = "signing";
  private animations:{[key:string]: AnimationItem|null} = {
    "signing": null,
    "success": null,
    "error": null,
    "already_signed": null
  };

  optionsSigning: AnimationOptions = {
    path: '/assets/lottie/signing.json'
  };

  optionsSuccess: AnimationOptions = {
    path: '/assets/lottie/success.json',
    loop: false
  };

  optionsError: AnimationOptions = {
    path: '/assets/lottie/error-robot.json',
    loop: false
  };

  optionsAlreadySigned: AnimationOptions = {
    path: '/assets/lottie/already_signed.json',
    loop: false
  };

  constructor(public dialogRef: MatDialogRef<PopupProgressSigningComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { signature_request:SignatureRequest, signature:Blob, dni?:string|null },
              private api:ApiService,
              private utils:UtilsService,
              private router:Router) {
    this.signature_request = data.signature_request;
    this.signature = data.signature;
    this.dni = data.dni ?? null;
  }

  ngOnInit(): void {
    this.sign();
  }

  finish(logout:boolean) {
    this.dialogRef.close({
      logout: logout
    })
  }

  retry() {
    this.sign();
  }

  retryAlsoSign() {
    this.sign(true);
  }

  onAnimCreated(anim:any, type:string) {
    this.animations[type] = anim;
  }

  private sign(signAlgoSign:boolean = false) {
    this.status = "signing";
    this.api.signDocumentRequest(this.signature_request.uuid, this.signature, signAlgoSign, this.dni).subscribe(
      async data => {
        await this.utils.delay(3000);
        this.showSuccess();
      },
      async error => {
        await this.utils.delay(3000);
        this.showError(error);
      }
    );
  }

  private showSuccess() {
    this.status = "success";
    this.playCurrentAnimation();
  }

  private showError(error:any) {
    switch(error.error.message){
      case ("You have already signed this document"):
        this.status = "already_signed";
        break;
      case (INVALIDATED_LINK_MESSAGE):
        this.dialogRef.close();
        this.router.navigate(['/signatures', 'invalidated']);
        break;
      default:
        this.status = "error";
        this.playCurrentAnimation();
        break;
    }

  }

  private playCurrentAnimation() {
    const item = this.animations[this.status];
    if(item != null) {
      item.goToAndPlay(0);
    }
  }

}
